<mat-dialog-actions [class.stacked]="stacked">
  @if (buttons.secondary) {
    <button
      class="secondary"
      [mat-dialog-close]="buttons.secondary.choice">
      {{ buttons.secondary.labelKey |
         translate:undefined:buttons.secondary.replacements }}
    </button>
  }
  @if (buttons.primary) {
    <button
      class="primary"
      [mat-dialog-close]="buttons.primary.choice">
      {{ buttons.primary.labelKey |
         translate:undefined:buttons.primary.replacements }}
    </button>
  }
</mat-dialog-actions>
